<template>
<div>
	<div v-for="(entry, index) in values" v-if="entry.value(entity)" class="tagged-pair">
		<v-chip label small :title="entry.title">
			<v-avatar class="grey lighten-1"><kbd :style="`background-color: ${colours(entry.label)}`">{{entry.label}}</kbd></v-avatar>
			<jm-cell style="display: inline;" :entity="entity" :view="entry" :key="entry.label+index"></jm-cell>
		</v-chip>
	</div>
</div>
</template>

<script>
import { ModelItemView, ModelTableView } from '@/assets/js/ModelView'

export default {
	name: "JmTagged",

	props: {
		content: Object,
		entity: Object
	},

	computed: {
		values () {
			this.content.props.map(() => {});
			return this.content.props;
		}
	},

	methods: {
		colours (key) {
			switch (key.toLowerCase()) {
				case "sta":
					return "#80deea";
				case "eta":
					return "#00acc1";
				case "ata":
					return "#00838f";
				case "std":
					return "#4fc3f7";
				case "etd":
					return "#039be5";
				case "atd":
					return "#0277bd";
				default:
					return "grey lighten-2";
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Tagged.vue